module.exports = __webpack_public_path__ + "img/4.f1f5856e.png";